<script lang="ts">
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system/index';
	//Stores
	import { home_data } from 'src/stores/account/user';
	//Services
	import { format } from '../../../services/i18n';
	//Utilities
	import { openExternalLink } from 'src/helpers/utilities';
	//Constants
	import { COUNTRIES } from 'src/constants';

	export let showInfoModal = false;
	export let codePopover = '';
</script>

<Modal
	showModal={showInfoModal}
	on:close={() => {
		showInfoModal = false;
		codePopover = '';
	}}
	title={$format('title_installer_details', {
		default: `Installer information details`,
	})}
>
	<Container slot="content" padding="0">
		<Text class="mb-s">
			<span class="text-bold">
				{$format('text_installer_code', { default: 'Code:' })}
			</span>
			<span class="text-200">
				{$home_data.icodes[codePopover].electrician_code || $home_data.icodes[codePopover].code}
			</span>
		</Text>
		<Text class="mb-s">
			<span class="text-bold">
				{$format('text_installer_email', { default: 'Email:' })}
			</span>
			<a
				href={`mailto:${$home_data.icodes[codePopover].electrician_email || $home_data.icodes[codePopover].email}`}
				class="link-styles text-200"
				>{$home_data.icodes[codePopover].electrician_email ||
					$home_data.icodes[codePopover].email}</a
			>
		</Text>
		<Text>
			<span class="text-bold">
				{$format('text_installer_phone', { default: 'Phone:' })}
			</span>
			<a href={`tel:${$home_data.icodes[codePopover].phone}`} class="link-styles text-200"
				>{$home_data.icodes[codePopover].phone}</a
			>
		</Text>
		<hr class="mb-l mt-l" />
		<Text class="mb-s">
			<span class="text-bold">
				{$format('text_installer_company_name', {
					default: 'Company name:',
				})}
			</span>
			<span class="text-200">
				{$home_data.icodes[codePopover]?.company_name}
			</span>
		</Text>
		<!-- <Text>
			<span class="text-bold">
				{$format('text_installer_company_details', {
					default: "Company details:",
				})}
			</span>
			<span class="text-200">
				{$home_data.icodes[codePopover]?.company_details}
			</span>
		</Text> -->
		{#if COUNTRIES.find((country) => country?.CountryCode === $home_data.icodes[codePopover]?.country)}
			<Text>
				<span class="text-bold">
					{$format('text_installer_company_country', {
						default: 'Company country:',
					})}
				</span>
				<span class="text-200">
					{COUNTRIES.find(
						(country) => country?.CountryCode === $home_data.icodes[codePopover]?.country,
					)?.CountryName}
				</span>
			</Text>
		{/if}
		{#if $home_data.icodes[codePopover]?.location?.address}
			<Text class="mt-s">
				<span class="text-bold">
					{$format('text_installer_company_address', {
						default: 'Company address:',
					})}
				</span>
				<span class="text-200">
					{$home_data.icodes[codePopover]?.location?.address}
				</span>
			</Text>
		{/if}
		{#if $home_data.icodes[codePopover]?.website}
			<Text class="mt-s">
				<span class="text-bold">
					{$format('text_installer_company_website', {
						default: 'Company website:',
					})}
				</span>
				<span
					tabindex="0"
					role="button"
					class="link-styles text-200"
					on:keydown
					on:click={() => {
						openExternalLink($home_data.icodes[codePopover]?.website);
					}}
				>
					{$home_data.icodes[codePopover]?.website}
				</span>
			</Text>
		{/if}
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="secondary"
			on:click={() => {
				showInfoModal = false;
				codePopover = '';
			}}
		>
			{$format('button_close', { default: 'Close' })}
		</Button>
	</div>
</Modal>
